import React from 'react';
import { connect } from 'tanok';
import { t } from 'c-3po';
import { toJS } from '../../helpers/ImmutableToJS';
import * as a from './../../../libs/actions';

import { Button } from '../../ui/button';

// styles
import css from './company.sss';

class UnbanView extends React.Component {
    handleCompanyUnblock = () => {
        this.props.send(a.EVENT_BESIDA_SEND_UNBAN_LIST);
    }

    render() {
        return (
            <div className={css.unban}>
                <div className={css.unbanText}>
                    {t`Вы можете разблокировать продавца.`}
                    {t`И получите возможность снова общаться в чате.`}
                </div>
                <Button
                    onClick={this.handleCompanyUnblock}
                >
                    {t`Разблокировать`}
                </Button>
            </div>
        );
    }
}

export const Unban = connect()(toJS(UnbanView));

